import mobile_1 from "/public/images/landing/responsibility/1_mobile.png";
import mobile_2 from "/public/images/landing/responsibility/2_mobile.png";
import mobile_3 from "/public/images/landing/responsibility/3_mobile.png";
import mobile_4 from "/public/images/landing/responsibility/4_mobile.png";

import desktop_1 from "/public/images/landing/responsibility/1.png";
import desktop_2 from "/public/images/landing/responsibility/2.png";
import desktop_3 from "/public/images/landing/responsibility/3.png";
import desktop_4 from "/public/images/landing/responsibility/4.png";

export const landingResponsibilityMobileData = (courseInfo: string) => [
  {
    number: "01",
    title: "이력서 & 포트폴리오 세션",
    img: mobile_1,
    desc: "채용 담당자의 특강을 통해 이력서를 업그레이드하고, 강점을 살려 나만의 포트폴리오를 완성합니다.",
  },
  {
    number: "02",
    title: `현직 ${courseInfo}과 모의 면접 진행`,
    img: mobile_2,
    desc: "면접 트레이닝으로 실전에 대비하고, 모의 면접에서 파악한 나만의 강점을 지원 프로필에 반영하여 서류 합격률을 높입니다.",
  },
  {
    number: "03",
    title: "모여서 각자 지원, 모각지 클럽",
    img: mobile_3,
    desc: "오프라인 세션에서 개별 취업 지원을 서포트합니다. 현장에서의 실시간 피드백을 통해 지원서를 고도화합니다.",
  },
  {
    number: "04",
    title: "커리어 매니저의 맞춤 지원 관리",
    img: mobile_4,
    desc: "주기적인 헬스 케어를 지원하며, 수강생의 성향에 대한 깊은 이해를 바탕으로 적합한 맞춤 기업을 추천해드립니다.",
  },
];

interface Point {
  seq: string;
  title: string;
  desc: string;
}

interface PMData {
  step: string;
  title: string;
  points: Point[];
}
export const landingResponsibilityPMMobileData: PMData[] = [
  {
    step: "Foundation",
    title: "커리어 매니저의\n" + "맞춤 지원 관리",
    points: [
      {
        seq: "0-1.",
        title: "수강생 헬스 케어",
        desc: "과정 종료 이후에도 커리어 매니저와의 지속적인 교류를 통해 취업 로드맵을 함께 구상합니다.",
      },
      {
        seq: "0-2.",
        title: "맞춤 기업 추천",
        desc: "지속적인 커리어 상담을 통해 파악한 수강생의 직무 성향을 바탕으로 맞춤 기업을 추천해드립니다.",
      },
    ],
  },
  {
    step: "Step 1.",
    title: "취업 시장\n" + "이해도 높이기",
    points: [
      {
        seq: "1-1.",
        title: "채용 담당자 특강",
        desc: "채용 담당자의 특강을 통해 이력서를 업그레이드하고, 강점을 살려 나만의 포트폴리오를 완성합니다.",
      },
      {
        seq: "1-2.",
        title: "현직 PM의 이력서 피드백",
        desc: "나의 강점이 드러날 수 있도록 실무자의 관점에서 이력서 및 포트폴리오 강화 전략을 코칭합니다.",
      },
    ],
  },
  {
    step: "Step 2.",
    title: "실습을 통한\n" + "취업 역량 강화",
    points: [
      {
        seq: "2-1.",
        title: "모여서 각자 지원, 모각지 클럽",
        desc: "오프라인 공간에 모여 서류 지원까지 해봅니다. 현장에서의 피드백을 통해 지원서를 고도화합니다.",
      },
      {
        seq: "2-2.",
        title: "현직 PM과 모의 면접 진행",
        desc: "면접 트레이닝으로 실전에 대비하고, 모의 면접에서 파악한 강점을 반영하여 서류 합격률을 높입니다.",
      },
    ],
  },
];

export const landingResponsibilityDesktopData = (courseInfo: string) => [
  {
    number: "01",
    title: "이력서 & 포트폴리오 세션",
    img: desktop_1,
    desc: "채용 담당자의 특강을 통해 이력서를 업그레이드하고, 강점을 살려 나만의 포트폴리오를 완성합니다.",
  },
  {
    number: "02",
    title: `현직 ${courseInfo} 모의 면접 진행`,
    img: desktop_2,
    desc: "면접 트레이닝으로 실전에 대비하고, 모의 면접에서 파악한 나만의 강점을 지원 프로필에 반영하여 서류 합격률을 높입니다.",
  },
  {
    number: "03",
    title: "모여서 각자 지원, 모각지 클럽",
    img: desktop_3,
    desc: "오프라인 세션에서 개별 취업 지원을 서포트합니다. 현장에서의 실시간 피드백을 통해 지원서를 고도화합니다.",
  },
  {
    number: "04",
    title: "커리어 매니저의 맞춤 지원 관리",
    img: desktop_4,
    desc: "주기적인 헬스 케어를 지원하며, 수강생의 성향에 대한 깊은 이해를 바탕으로 적합한 맞춤 기업을 추천해드립니다.",
  },
];
